import { FormattedNumber } from 'react-intl';

type CurrencyProps = {
  value?: number;
};

export function Currency({ value }: CurrencyProps) {
  return <FormattedNumber value={value ?? 0} style="currency" currency="USD" minimumFractionDigits={0} />;
}
